import { createContext, useContext } from 'react';

/**
 * The surface the shared marketing chrome sits on.
 *
 * `<html>` carries a forced `dark` class app-wide (the designer needs it), so
 * a component cannot read the page's brightness from the theme: a light page
 * would still get the light-on-dark wordmark. RootLayout publishes the tone of
 * the shell it applied and `MarketingHeader` reads it, so every marketing page
 * gets the blue/red wordmark on the DARK variant (the one made for light
 * grounds) without passing a prop from 68 pages. An explicit `tone` prop still
 * wins.
 */
export type MarketingTone = 'light' | 'dark';

export const MarketingToneContext = createContext<MarketingTone | undefined>(undefined);

export const useMarketingTone = (): MarketingTone | undefined => useContext(MarketingToneContext);
